import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import axios from "axios";
import { useForm } from "react-hook-form";
import { Header2 } from "../components/elements/Header";
import { Avatar, ImagePlacer, Initials } from "../components/elements/Avatar";
import { useAuth } from "../context/auth";
import { FormInput, InputLabel, AreaInput } from "../components/elements/Input";
import Popup from "reactjs-popup";
import authHeader from "../services/auth.header";
import { DropDownList, ListItem } from "../components/elements/List";
import camera from "../assets/svg/camera.svg";
import gallery from "../assets/svg/gallery.svg";
import Buttons from "../components/elements/Button";
import { navigate } from "@reach/router";

const ChangeBtn = styled.button`
  margin-left: -80px;
  z-index: 1;
  border: none;
  background: transparent;
  color: #fdfffc;
  font-size: 14px;
  text-align: center;
  font-weight: 500;
  text-decoration: underline;
  text-decoration-color: #f89825;
  text-decoration-thickness: 2px;
  cursor: pointer;
`;

const StyledPopup = styled(Popup)`
  position: fixed;
  &-overlay {
    -webkit-backdrop-filter: blur(20px);
    backdrop-filter: blur(20px);
    background-color: rgba(4, 3, 3, 0.7);
  }
  &-content {
    color: #fdfffc;
    top: auto !important;
    bottom: 0px !important;
    overflow: auto;
    right: auto;
    width: 100%;
    left: 0px !important;
    border-radius: 20px;
    outline: none;
    padding-bottom: 10px;
    background-color: #040303;
    padding: 25px;
  }
`;

const Edit = styled.p`
  font-family: Poppins;
  color: #fdfffc;
  font-size: 14px;
  text-align: center;
  font-weight: 500;
  text-decoration: underline;
  text-decoration-color: #f89825;
  text-decoration-thickness: 2px;
  cursor: pointer;
  &:hover {
    color: #fd9e46;
    cursor: pointer;
  }
`;

const LabelSvg = styled.img`
  display: block;
  top: 0;
  left: 0;
  overflow: visible;
  width: 39px;
  height: 18px;
`;

export default function EditProfile(props) {
  const { user, updateUser } = useAuth();

  const getInitials = () => {
    const initials = user.data
      ? user.data.fullName.trim().split(" ")
      : user.fullName.trim().split(" ");
    if (initials.length === 1) return `${initials[0].charAt(0)}`;
    else
      return `${initials[0].charAt(0)}${initials[initials.length - 1].charAt(
        0
      )}`;
  };

  const short = getInitials();
  const inputFile = useRef(null);
  const [selectedimage, setSelectedimage] = useState(null);
  const [add, setAdd] = useState();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      fullName: `${user && user.data ? user.data.fullName : user.fullName}`,
      displayName: `${user && user.data ? user.data.displayName : null}`,
      password: "123456789",
    },
  });

  const defaultPw = "123456";
  const BASE_URL = "https://catway.services.ombre.app/v1/";
  useEffect(() => {
    getAdd();
  }, []);

  const getAdd = () => {
    return axios
      .get(
        BASE_URL +
          "users/" +
          `${user && user.data ? user.data.id : user.id}` +
          "/profile" +
          "/settings",
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        setAdd(response.data.data.address);
        reset({
          fullName: user.data.fullName,
          displayName: user.data.displayName,
        });
      });
  };

  const onImageClick = () => {
    inputFile.current.click();
  };

  const updateAvatar = () => {};

  const onSubmit = (data) => {
    const formData = new FormData();
    formData.append("avatar", selectedimage);
    updateUser(data.fullName, data.displayName)
      .then(() => {
        reset({
          fullName: data.fullName,
          displayName: data.displayName,
        });
        navigate("/profile");
      })
      .catch(() => {
        console.log("error");
      });
    return axios
      .post(
        BASE_URL +
          "users/" +
          `${user && user.data ? user.data.id : user.id}` +
          "/avatar",
        formData,
        {
          headers: {
            "Content-type": "multipart/form-data",
            Authorization: "Bearer " + user.data.token.access_token,
          },
        }
      )
      .catch(() => {
        console.log("error");
      });
  };

  return (
    <>
      <Header2 style={{ marginTop: "70px" }}>My profile</Header2>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div
          style={{ marginTop: "20px" }}
          className="d-flex justify-content-center"
        >
          <ImagePlacer className="d-flex justify-content-center">
            {selectedimage ? (
              <Avatar src={URL.createObjectURL(selectedimage)} />
            ) : user && user.data ? (
              <Avatar src={user.data.avatar} />
            ) : (
              <Initials className="align-self-center">{short}</Initials>
            )}
          </ImagePlacer>
        </div>
        <div
          style={{ marginTop: "16px" }}
          className="d-flex justify-content-center"
        >
          <StyledPopup
            trigger={<Edit>Change profile picture</Edit>}
            arrow="false"
          >
            <DropDownList>
              <ListItem>
                <div className="d-flex row">
                  <LabelSvg src={camera} />
                  Take picture
                </div>
              </ListItem>
              <ListItem onClick={onImageClick}>
                <div className="d-flex row">
                  <LabelSvg src={gallery} />
                  Image gallery
                </div>
              </ListItem>
            </DropDownList>
          </StyledPopup>
        </div>
        <div>
          <div className="mt-3">
            <InputLabel>Email Address:</InputLabel>
          </div>
          <div className="d-flex px-3">
            {user && user.data ? (
              <FormInput defaultValue={user.data.email} />
            ) : (
              <FormInput defaultValue={user.email} />
            )}
            <ChangeBtn
              onClick={(e) => {
                e.preventDefault();
                navigate("/email");
              }}
            >
              Change
            </ChangeBtn>
          </div>
          <div className="mt-3">
            <InputLabel>Name:</InputLabel>
          </div>
          <div className="d-flex px-3">
            <FormInput {...register("fullName")} />
          </div>
          <div className="mt-3">
            <InputLabel>Display name:</InputLabel>
          </div>
          <div className="px-3">
            <FormInput {...register("displayName")} />
          </div>
          <div className="mt-3">
            <InputLabel>Password:</InputLabel>
          </div>
          <div className="d-flex px-3">
            <FormInput type="password" defaultValue={defaultPw} />
            <ChangeBtn onClick={(e) => e.preventDefault()}>Change</ChangeBtn>
          </div>
          <div className="mt-3">
            <InputLabel>Address:</InputLabel>
          </div>
          <div className="d-flex px-3">
            {add && add.address ? (
              <AreaInput
                {...register("address")}
                disabled
                defaultValue={
                  (add &&
                    add.address +
                      ", " +
                      add.zipCode +
                      ", " +
                      add.city +
                      ", " +
                      add.state +
                      ", " +
                      add.country) ||
                  ""
                }
              />
            ) : (
              <AreaInput />
            )}
            <ChangeBtn
              onClick={(e) => {
                e.preventDefault();
                navigate("/address");
              }}
            >
              Change
            </ChangeBtn>
          </div>
        </div>
        <div style={{ marginTop: "20px", marginBottom: "30px" }}>
          <Buttons type="submit" mode="Dark" autoWidth={true} types="Primary">
            Update
          </Buttons>
        </div>
      </form>
      <input
        type="file"
        id="file"
        ref={inputFile}
        style={{ display: "none" }}
        onChange={(event) => {
          setSelectedimage(event.target.files[0]);
        }}
      />
    </>
  );
}
